<template>
  <div>
    <v-label v-if="label">{{label}}</v-label>
    <v-layout>

      <v-flex xs1>
        <date-time-input v-model="from"
                         label="From"
                         :show-now="false"
                         :required="required && !disabled"
                         :max-datetime="to"
                         :disabled="disabled"
                         :value-post-processor="fromValuePostProcessor"/>
      </v-flex>
      <v-flex xs1>
        <date-time-input v-model="to"
                         label="To"
                         :show-now="false"
                         :required="required && !disabled"
                         :min-datetime="from"
                         :disabled="disabled"
                         :value-post-processor="toValuePostProcessor"/>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import moment from 'moment'
  import DateTimeInput from './DateTimeInput'

  export default {
    name: 'date-range-input',
    components: {
      DateTimeInput,
    },
    props: {
      value: {
        type: Object,
      },
      label: {
        type: String,
      },
      type: {
        type: String,
        default: 'datetime'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      required: {
        type: Boolean,
        default: true,
      },
      fromValuePostProcessor: {
        type: Function,
        default: value => value
      },
      toValuePostProcessor: {
        type: Function,
        default: value => value
      },
    },
    data() {
      return {}
    },
    computed: {
      from: {
        get() {
          if (!this.value) {
            return null
          }

          return this.value.from
        },
        set(newValueFrom) {
          let oldFromValue = null;
          if (this.value) {
            oldFromValue = this.value.from;
          }
          if (moment(newValueFrom).isSame(oldFromValue)) {
            return
          }

          let toValue = null;
          if (this.value) {
            toValue = this.value.to
          }

          let newValue = {
            from: newValueFrom,
            to: toValue
          };

          this.$emit('input', newValue)
        }
      },
      to: {
        get() {
          if (!this.value) {
            return null
          }

          return this.value.to
        },
        set(newValueTo) {
          let oldToValue = null;
          if (this.value) {
            oldToValue = this.value.from;
          }
          if (moment(newValueTo).isSame(oldToValue)) {
            return
          }

          let fromValue = null;
          if (this.value) {
            fromValue = this.value.from
          }

          let newValue = {
            from: fromValue,
            to: newValueTo
          };

          this.$emit('input', newValue)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Ui/DateRangeInput.vue